import { Components, createTheme, Theme } from '@mui/material'
import { TypographyVariantsOptions } from '@mui/material/styles'
import { colorPalette as palette } from '~/constants/styles/colors'
import { button, typography } from '~/constants/styles/typography'

export const MuiTypography: TypographyVariantsOptions = {
  fontFamily: `Roboto, 'Noto Sans JP', -apple-system, 'Segoe UI', sans-serif`,
  button: {
    textTransform: 'none',
  },
  overline: {
    textTransform: 'none',
  },
}
export const components: Components<Omit<Theme, 'components'>> = {
  // テキスト系
  MuiTypography: {
    variants: [
      {
        props: { variant: 'h1' },
        style: typography.headingXL,
      },
      {
        props: { variant: 'h2' },
        style: typography.headingL,
      },
      {
        props: { variant: 'h3' },
        style: typography.headingM,
      },
      {
        props: { variant: 'h4' },
        style: typography.headingS,
      },
      {
        props: { variant: 'h5' },
        style: typography.headingXS,
      },
      {
        props: { variant: 'h6' },
        style: typography.headingXS,
      },
      {
        props: { variant: 'body1' },
        style: typography.bodyL,
      },
      {
        props: { variant: 'body2' },
        style: typography.bodyM,
      },
      {
        props: { variant: 'caption' },
        style: {
          fontSize: 12,
          fontWeight: 400,
          lineHeight: 1.43,
          letterSpacing: '0.03333em',
        },
      },
      {
        props: { variant: 'subtitle1' },
        style: typography.headingS,
      },
      {
        props: { variant: 'subtitle2' },
        style: typography.headingXS,
      },
      {
        props: { variant: 'headingXXL' },
        style: typography.headingXXL,
      },
      {
        props: { variant: 'headingXL' },
        style: typography.headingXL,
      },
      {
        props: { variant: 'headingL' },
        style: typography.headingL,
      },
      {
        props: { variant: 'headingM' },
        style: typography.headingM,
      },
      {
        props: { variant: 'headingS' },
        style: typography.headingS,
      },
      {
        props: { variant: 'headingXS' },
        style: typography.headingXS,
      },
      {
        props: { variant: 'bodyL' },
        style: typography.bodyL,
      },
      {
        props: { variant: 'bodyM' },
        style: typography.bodyM,
      },
      {
        props: { variant: 'labelLJpNormal' },
        style: typography.labelLJpNormal,
      },
      {
        props: { variant: 'labelLJpNormalBold' },
        style: typography.labelLJpNormalBold,
      },
      {
        props: { variant: 'labelLJpTight' },
        style: typography.labelLJpTight,
      },
      {
        props: { variant: 'labelMJpNormal' },
        style: typography.labelMJpNormal,
      },
      {
        props: { variant: 'labelMJpNormalMedium' },
        style: typography.labelMJpNormalMedium,
      },
      {
        props: { variant: 'labelMJpTight' },
        style: typography.labelMJpTight,
      },
      {
        props: { variant: 'labelSJpNormal' },
        style: typography.labelSJpNormal,
      },
      {
        props: { variant: 'labelSJpTight' },
        style: typography.labelSJpTight,
      },
      {
        props: { variant: 'labelSJpTightRegular' },
        style: typography.labelSJpTightRegular,
      },
      {
        props: { variant: 'labelSJpNormalRegular' },
        style: typography.labelSJpNormalRegular,
      },
      {
        props: { variant: 'labelXsJpNormal' },
        style: typography.labelXsJpNormal,
      },
      {
        props: { variant: 'labelXsJpTight' },
        style: typography.labelXsJpTight,
      },
      {
        props: { variant: 'labelMEnNormal' },
        style: typography.labelMEnNormal,
      },
      {
        props: { variant: 'labelMEnTight' },
        style: typography.labelMEnTight,
      },
      {
        props: { variant: 'labelSEnNormal' },
        style: typography.labelSEnNormal,
      },
      {
        props: { variant: 'labelSEnNormalMedium' },
        style: typography.labelSEnNormalMedium,
      },
      {
        props: { variant: 'labelSEnTight' },
        style: typography.labelSEnTight,
      },
      {
        props: { variant: 'labelXsEnNormal' },
        style: typography.labelXsEnNormal,
      },
      {
        props: { variant: 'labelXsEnTight' },
        style: typography.labelXsEnTight,
      },
      {
        props: { variant: 'labelXsJpNormalMedium' },
        style: typography.labelXsJpNormalMedium,
      },
      {
        props: { variant: 'labelXsJpNormalBold' },
        style: typography.labelXsJpNormalBold,
      },
      {
        props: { variant: 'labelXsJpNormalRegular' },
        style: typography.labelXsJpNormalRegular,
      },
      {
        props: { variant: 'labelSJpTightRegular' },
        style: typography.labelSJpTightRegular,
      },
    ],
  },
  MuiLink: {
    defaultProps: {
      underline: 'none',
    },
  },
  MuiSelect: {
    defaultProps: {
      size: 'small',
    },
    variants: [
      {
        props: {
          variant: 'outlined',
          size: 'small',
        },
        style: {},
      },
      {
        props: {
          variant: 'filled',
          size: 'small',
        },
        style: {},
      },

      {
        props: {
          variant: 'standard',
          size: 'small',
        },
        style: {},
      },
    ],
  },
  MuiTextField: {
    defaultProps: {
      size: 'small',
    },
    variants: [
      {
        props: {
          variant: 'outlined',
          size: 'small',
        },
        style: {},
      },
      {
        props: {
          variant: 'filled',
          size: 'small',
        },
        style: {},
      },
      {
        props: {
          variant: 'standard',
          size: 'small',
        },
        style: {},
      },
    ],
  },
  // ボタン系
  MuiButton: {
    variants: [
      // カラーによって、ホバーなどのスタイルを変更
      {
        props: { color: 'primary' },
        style: {
          ':disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
          },
        },
      },
      // サイズによって、ボタンのスタイルを変更
      {
        props: { size: 'small' },
        style: button.sizeS,
      },
      {
        props: { size: 'medium' },
        style: button.sizeM,
      },
      {
        props: { size: 'large' },
        style: button.sizeL,
      },
    ],
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        '&&.Mui-selected': {
          backgroundColor: palette.action.selected,
        },
        '&&.Mui-selected:hover': {
          backgroundColor: palette.action.hover,
        },
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        color: palette.text.primary,
      },
    },
  },
  MuiCheckbox: { defaultProps: { color: 'primary' } },
  MuiRadio: { defaultProps: { color: 'primary' } },
  MuiSwitch: { defaultProps: { color: 'primary' } },
  // Table系
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontSize: 14,
        fontWeight: 700,
        wordBreak: 'keep-all',
        whiteSpace: 'nowrap',
      },
      body: {
        fontSize: 14,
        fontWeight: 400,
        ['& > *']: {
          width: 'max-content',
          maxWidth: '60vw',
        },
      },
    },
  },
  // その他
  MuiAppBar: { defaultProps: { color: 'inherit' } },
  MuiAlert: {
    variants: [
      {
        props: { severity: 'success', variant: 'filled' },
        style: {
          backgroundColor: palette.success.main,
          '& .MuiAlert-title': {
            color: palette.text.invertPrimary,
          },
          '& .MuiAlert-message': {
            color: palette.text.invertPrimary,
          },
        },
      },
      {
        props: { severity: 'error', variant: 'filled' },
        style: {
          backgroundColor: palette.error.main,
          '& .MuiAlert-title': {
            color: palette.text.invertPrimary,
          },
          '& .MuiAlert-message': {
            color: palette.text.invertPrimary,
          },
        },
      },
      {
        props: { severity: 'warning', variant: 'filled' },
        style: {
          backgroundColor: palette.warning.light,
          '& .MuiAlert-title': {
            color: palette.text.invertPrimary,
          },
          '& .MuiAlert-message': {
            color: palette.text.invertPrimary,
          },
        },
      },
      {
        props: { severity: 'info', variant: 'filled' },
        style: {
          backgroundColor: palette.info.main,
          '& .MuiAlert-title': {
            color: palette.text.invertPrimary,
          },
          '& .MuiAlert-message': {
            color: palette.text.invertPrimary,
          },
        },
      },
      {
        props: { severity: 'success', variant: 'outlined' },
        style: {
          backgroundColor: 'transparent',
          borderColor: palette.success.outlineBorder,
          '& .MuiAlert-title': {
            color: palette.success['160p'],
          },
          '& .MuiAlert-message': {
            color: palette.success['160p'],
            ...typography.bodyM,
          },
        },
      },
      {
        props: { severity: 'error', variant: 'outlined' },
        style: {
          backgroundColor: 'transparent',
          borderColor: palette.error.outlineBorder,
          '& .MuiAlert-title': {
            color: palette.error['160p'],
          },
          '& .MuiAlert-message': {
            color: palette.error['160p'],
            ...typography.bodyM,
          },
        },
      },
      {
        props: { severity: 'warning', variant: 'outlined' },
        style: {
          backgroundColor: 'transparent',
          borderColor: palette.warning.outlineBorder,
          '& .MuiAlert-title': {
            color: palette.warning['160p'],
          },
          '& .MuiAlert-message': {
            color: palette.warning['160p'],
            ...typography.bodyM,
          },
        },
      },
      {
        props: { severity: 'info', variant: 'outlined' },
        style: {
          backgroundColor: 'transparent',
          borderColor: palette.info.outlineBorder,
          '& .MuiAlert-title': {
            color: palette.info['160p'],
          },
          '& .MuiAlert-message': {
            color: palette.info['160p'],
            ...typography.bodyM,
          },
        },
      },
      {
        props: { severity: 'success', variant: 'standard' },
        style: {
          backgroundColor: palette.success['190p'],
          '& .MuiAlert-title': {
            color: palette.success['160p'],
          },
          '& .MuiAlert-message': {
            color: palette.success['160p'],
          },
        },
      },
      {
        props: { severity: 'error', variant: 'standard' },
        style: {
          backgroundColor: palette.error['190p'],
          '& .MuiAlert-title': {
            color: palette.error['160p'],
          },
          '& .MuiAlert-message': {
            color: palette.error['160p'],
          },
        },
      },
      {
        props: { severity: 'warning', variant: 'standard' },
        style: {
          backgroundColor: palette.warning['190p'],
          '& .MuiAlert-title': {
            color: palette.warning['160p'],
          },
          '& .MuiAlert-message': {
            color: palette.warning['160p'],
          },
        },
      },
      {
        props: { severity: 'info', variant: 'standard' },
        style: {
          backgroundColor: palette.info['190p'],
          '& .MuiAlert-title': {
            color: palette.info['160p'],
          },
          '& .MuiAlert-message': {
            color: palette.info['160p'],
          },
        },
      },
    ],
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        fontSize: 10,
        fontWeight: 500,
        lineHeight: 1.43,
        letterSpacing: 0,
      },
    },
  },
}
export const theme = createTheme({
  typography: MuiTypography,
  palette,
  components,
})
export const drawerWidth = 240
